import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { styled } from '@stitches/react';

// 导入子页面组件（将在后续创建）
import CloudMiningOverview from './CloudMiningOverview';
import CloudMiningContracts from './CloudMiningContracts';
import CloudMiningCalculator from './CloudMiningCalculator';
import CloudMiningFaq from './CloudMiningFaq';

// 云挖矿容器样式
const CloudMiningContainer = styled('div', {
  width: '100%',
  maxWidth: '1200px',
  margin: '0 auto',
  padding: '0 1rem',
  backgroundColor: 'var(--surface-color)',
  color: 'var(--text-primary)'
});

/**
 * 云挖矿模块主组件
 * 管理云挖矿相关路由
 */
const CloudMining: React.FC = () => {
  // const { t } = useTranslation(); // 暂时未使用
  
  return (
    <CloudMiningContainer>
      <Routes>
        <Route path="/" element={<Navigate to="overview" replace />} />
        <Route path="overview" element={<CloudMiningOverview />} />
        <Route path="contracts" element={<CloudMiningContracts />} />
        <Route path="calculator" element={<CloudMiningCalculator />} />
        <Route path="faq" element={<CloudMiningFaq />} />
      </Routes>
    </CloudMiningContainer>
  );
};

export default CloudMining; 